/* ============================================================================
   CPX Bundle Cart — réconciliation des options « pack » liées à un produit.

   Une option payante (produit compagnon) est ajoutée avec les propriétés cachées
   `_bundle: <clé>` + `_bundled: true`, et le produit parent porte la même clé
   `_bundle`. L'option est verrouillée dans le panier (ni quantité ni suppression
   — voir CSS .cpx-locked-line). Ici on garantit qu'une option ne reste JAMAIS
   seule : si son parent disparaît, on la retire automatiquement.
   ============================================================================ */
(function () {
  var busy = false;

  function isOption(item) {
    var p = item.properties || {};
    return p._bundled === 'true' || p._bundled === true;
  }

  function refresh(remaining) {
    // Page panier : rechargement simple. Tiroir : re-render des sections.
    if (location.pathname.indexOf('/cart') === 0 && document.querySelector('#main-cart-items, cart-items')) {
      location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;
    var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    fetch('/?sections=' + encodeURIComponent(ids), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.renderContents({ sections: sections });
        if (remaining > 0) drawer.classList.remove('is-empty');
        else drawer.classList.add('is-empty');
      })
      .catch(function () {});
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Clés _bundle présentes sur des lignes PARENT (non-option).
        var parents = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._bundle && !isOption(it)) parents[p._bundle] = true;
        });
        // Options dont le parent a disparu (ou sans clé) = orphelines.
        var orphans = cart.items.filter(function (it) {
          var p = it.properties || {};
          return isOption(it) && (!p._bundle || !parents[p._bundle]);
        });
        if (!orphans.length) { busy = false; return; }

        var remaining = cart.items.length - orphans.length;
        orphans.reduce(function (chain, it) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 0 })
            });
          });
        }, Promise.resolve())
          .then(function () { busy = false; refresh(remaining); })
          .catch(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  function init() {
    reconcile(); // au chargement : nettoie un éventuel orphelin déjà présent
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { reconcile(); });
    }
    document.addEventListener('cart:refresh', reconcile); // filet de sécurité
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
